import { twMerge } from 'tailwind-merge';

const DEFAULT_CLASS_NAME =
  'py-[7px] px-6 rounded-full text-[16px]/[24px] text-medium text-brand-900 border border-brand-900 bg-transparent box-border outline-none';
const PRIMARY_CLASS_NAME =
  'hover:text-white hover:bg-success-500 hover:border-success-500 focus:text-white focus:bg-success-500 focus:border-success-500';
const SECONDARY_CLASS_NAME =
  'hover:text-white hover:bg-destructive-500 hover:border-destructive-500 focus:text-white focus:bg-destructive-500 focus:border-destructive-500';
const SELECTED_PRIMARY_CLASS_NAME =
  'text-white bg-success-500 border-success-500';
const SELECTED_SECONDARY_CLASS_NAME =
  'text-white bg-destructive-500 border-destructive-500';

export const SelectableItem = ({
  label,
  selected = false,
  variant,
  onClick,
}) => {
  const className = twMerge(
    DEFAULT_CLASS_NAME,
    variant === 'primary' && PRIMARY_CLASS_NAME,
    variant === 'primary' && selected && SELECTED_PRIMARY_CLASS_NAME,
    variant === 'secondary' && SECONDARY_CLASS_NAME,
    variant === 'secondary' && selected && SELECTED_SECONDARY_CLASS_NAME,
  );

  return (
    <button onClick={onClick} className={className}>
      {label}
    </button>
  );
};
